import { RiskLevel } from '@models/assessment';

import { Gender } from 'generated/types';

import type { ReferenceRange } from './types';

const referenceRange: ReferenceRange<RiskLevel> = new Map([
  [
    Gender.unknown,
    new Map([
      [
        RiskLevel.Low,
        [
          {
            upper: 0.5,
          },
        ],
      ],
      [
        RiskLevel.Medium,
        [
          {
            lower: 0.5,
            upper: 0.6,
          },
        ],
      ],
      [
        RiskLevel.High,
        [
          {
            lower: 0.6,
            upper: 1.2,
          },
        ],
      ],
    ]),
  ],
]);

export default referenceRange;
